/* eslint-disable import/no-anonymous-default-export */


export default 
{
  "root": {
    "props": {}
  },
  "content": [
    {
      "type": "ContractName",
      "props": {
        "title": "{CONTRACT_NAME}",
        "id": "ContractName-768a1ad8-8bb3-4e74-a772-ee4f9b2bb106"
      }
    },
    {
      "type": "GRD_3CM_NOPAD",
      "props": {
        "rightColumn": [
          {
            "type": "INFO_ContractTimeline",
            "props": {
              "id": "INFO_ContractTimeline-e8ccbdbf-16cd-454f-b0c1-e15be1af4e9f"
            }
          }
        ],
        "middleColumn": [
          {
            "type": "INFO_ContractPrice",
            "props": {
              "id": "INFO_ContractPrice-4efcc4f6-8d48-4995-8f7a-4add4e6bd2b2"
            }
          }
        ],
        "leftColumn": [
          {
            "type": "INFO_ContractParties",
            "props": {
              "id": "INFO_ContractParties-4e1ff64d-84b9-4ad0-a0d3-c9236cc04e74"
            }
          }
        ],
        "id": "GRD_3CM_NOPAD-a8ce8de8-3e7b-4c9f-aff5-50f7100aeb61"
      }
    },
    {
      "type": "GRD_3CM_NOPAD",
      "props": {
        "rightColumn": [
          {
            "type": "INFO_ContractActions",
            "props": {
              "id": "INFO_ContractActions-e1bbdbc9-5664-458a-9656-b09c06a01318"
            }
          }
        ],
        "middleColumn": [
          {
            "type": "INFO_ContractPayments",
            "props": {
              "id": "INFO_ContractPayments-bb3a4259-192b-4d96-80b2-fbe669049287"
            }
          }
        ],
        "leftColumn": [
          {
            "type": "INFO_ProgramTimeline",
            "props": {
              "id": "INFO_ProgramTimeline-2912cabf-50c9-4326-b30b-abd933147e58"
            }
          }
        ],
        "id": "GRD_3CM_NOPAD-abc923bc-cbe8-4e36-89f7-ee12439747a6"
      }
    },
    {
      "type": "GRD_2CW",
      "props": {
        "rightColumn": [
          {
            "type": "ContractCalendar",
            "props": {
              "id": "ContractCalendar-7c000a98-0ec1-46a6-aa2c-9d3669afa2ef"
            }
          }
        ],
        "leftColumn": [
          {
            "type": "GRD_2Cx2C_M",
            "props": {
              "slot4": [
                {
                  "type": "CHART_CENImplemented",
                  "props": {
                    "id": "CHART_CENImplemented-455445c9-5f04-44db-baa1-86b3614f570f"
                  }
                }
              ],
              "slot3": [
                {
                  "type": "CHART_CEN",
                  "props": {
                    "id": "CHART_CEN-df64b298-667d-44df-b95b-f5392a93e5ff"
                  }
                }
              ],
              "slot2": [
                {
                  "type": "CHART_EWRisk",
                  "props": {
                    "id": "CHART_EWRisk-ffdb4e5c-cfdd-4cdf-ac26-1cfffc5ea5b3"
                  }
                }
              ],
              "slot1": [
                {
                  "type": "CHART_EW",
                  "props": {
                    "id": "CHART_EW-f440a0c5-95f5-4b57-93bf-17d970092d50"
                  }
                }
              ],
              "id": "GRD_2Cx2C_M-2b66e597-8c9e-454e-83df-84c5df90ad28"
            }
          }
        ],
        "id": "GRD_2CW-ddea0659-257f-4711-9816-df187ac96dc7"
      }
    }
  ],
  "zones": {}
};